// AutoGenerated
export class SezonSarkiModel {
    sezonModelId!: string;
    kayitTarihi!: Date | null;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}